function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3339"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2866",
  d: "M165.873 41.044c28.525-1.268 70.3.236 99.269-6.605 2.348-.555 46.959 83.106 47.081 101.751.085 12.9-29.2 50.244-35.645 55.868-16.178 14.127-40.64 17.451-116.24 20.569-20.1.828-94.65-1.88-112.5-23.328-13.606-16.35-30.9-48.18-30.086-51.63 10.178-43.111 42.142-98.935 44.4-98.8 29.627 1.791 83.107 3.092 103.721 2.175z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2867",
  d: "M64.292 39.093c-5.266 9.2-28.041 59.106-29.548 79.528-.163 2.2-12.05 30.785-12.05 30.785",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2868",
  d: "M261.467 35.303c6.336 8.264 32.135 58.273 33.041 80.9.092 2.3 12.428 34.154 12.428 34.154",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2869",
  d: "M30.134 131.218c8.948-.958 13.241-1.005 15.245 1.281s-.56 2.158 2.538 4.576 40.443 28 52.457 27.647c29.085-.848 56.374-1.43 63.569-1.379s36.771 1.194 59.046 1.235c9.459.017 35.066-11.339 58.3-30.184 0 0 .172-4.177 3.813-5.745l13.626.058",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2870",
  d: "M25.838 155.572c6.956 1.237 16.475-1.147 18-.515 14.015 5.807 46.683 21.167 54.582 21.992 10.9 1.137 47.174.231 63.32.33s58.614-.91 61.685-.436c10.572 1.638 57.146-23.645 63.344-22.687a149.828 149.828 0 0116.283 3.6",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2871",
  d: "M113.777 178.705c-2.155 7.192-2.513 18.777-2.513 18.777s32.674 5.747 51.782 5.457 50.518-4.742 50.518-4.742.945-5.544-3.654-21.127",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2872",
  d: "M233.983 115.172l4.409 6.826 2.816-.8-4.239-6.639z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3240"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2873",
  d: "M257.813 109.859l4.409 6.826 2.816-.8-4.24-6.639z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2874",
  d: "M115.793 164.115c2.254-7.207 11.975-16.543 18.129-16.591 11.091-.086 56.268 1.893 60.142-1.44s13.2-13.155 43.653-13.966l-.97-.747s11.555-6.4 33.3-9.867c.71-.114 2.439 4.5 2.726 5.686.241 1-1.013 3.559-3.72 4.735-3.583 1.556-12.041 6.059-13.184 9.858-2.042 6.791.332 5.647-8.349 8.276-8.183 2.479-27.68 9.189-31.8 14.393",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2875",
  d: "M224.79 133.031c1.561-5.1 2.157-11.3 5.949-12.228s5.871-1.463 5.871-1.463",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2876",
  d: "M239.76 118.712l20.5-4.976",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2877",
  d: "M263.452 113.078l7.958-1.706.833 1.093-2.333 3.312 3.026 4.518-1.471 3.33",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2878",
  d: "M169.646 148.025c8.663-6.93 42.405-41.98 49.683-40.525s7.765 21.264 3.187 23.84c-5.2 2.929-6.47 3.454-6.47 3.454",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2879",
  d: "M160.932 115.453c-1.458 2.409-9.492 7.821-11.259 13.687s-4.481 14.487-6.812 16.564",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2880",
  d: "M209.526 112.32c2.419-4.391 5.892-10.14 7.14-10.964 3.934-2.594 23.836-5.914 25.584-4.525s2.274 4.752 11.067 4.435c1.141-.041 11.125 9.594 11.125 9.594l5.052-1.334 1.808 1.717",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2881",
  d: "M167.973 118.617c1.135-1.443 24.138-2.5 25.038-1.081.862 1.358.856 5.579-.255 6.717-.942.966-23.3 2.77-24.683 1.194-1.315-1.496-1.291-5.316-.1-6.83z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2882",
  d: "M166.946 121.887c-.126-3.2-.454-7.332.856-8.315s21.8-2.691 24.337-1.283c1.587.881 1.491 8.073 1.491 8.073",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2883",
  d: "M196.283 73.23c-14.688-1.457-82.591-.5-87.442 4.7-1.259 1.351-2.258 8.964-3.746 14.781-.759 2.965 10.676-1.074 13.33 4.265 1.322 2.66 1.24 13.835 3.855 14.249 2.329.368 41.053.512 42.277-1.733 2.938-5.4 4.081-16.178 7.905-17.577 6.939-2.538 20-3.216 23.619-5.418.89-.545 1.266-13.162.202-13.267z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2884",
  d: "M196.538 73.388s2.372 14.251.333 16.817-23.779 5.888-25.515 8.455-4.185 15.977-8.262 16.581-24.212 1.147-24.306 2.531c-.183 2.673-3.657 12.615-12.919 13.242-6.575.445-19.307.869-20.036-3.391-1.023-5.979-1.931-11.74-1.825-14.14s2.406-12.03 2.406-12.03l-1.332-8.389",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2885",
  d: "M119.92 105.986c.6 6.156.551 9.3 3.1 10.306.162.064-18.533 2.343-19.031-2.672",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3241"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 14",
  cx: 6.561,
  cy: 3.766,
  rx: 6.561,
  ry: 3.766,
  transform: "rotate(-22.37 314.003 -212.214)",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3242"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 15",
  cx: 6.276,
  cy: 4.805,
  rx: 6.276,
  ry: 4.805,
  transform: "rotate(-27.321 297.909 -74.503)",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3243"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 16",
  cx: 8.19,
  cy: 5.002,
  rx: 8.19,
  ry: 5.002,
  transform: "rotate(-16.319 395.188 -212.05)",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2886",
  d: "M37.917 130.527c2.061-5.081 1.684-9.943 3.82-16.5s8.313-30.481 12-33.3 29.28-.509 52.081-5.251c2.94-.611 6.891-3.279 16.274-5.17s74.361-4.482 82.18-.8 2.631 3.435 16 4.446 49.565 3.358 51.337 4.781c6.593 5.3 16.765 45.5 18.493 49.865",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2887",
  d: "M69.296 131.997a8.538 8.538 0 00-.5 5.188c.933 4.537 6.27 5.931 10.965 4.595a12.014 12.014 0 005.6-3.761 8.118 8.118 0 001.661-4.707 6.161 6.161 0 00-6.311-6.587",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2888",
  d: "M69.546 132.519c.643 4.1 3.92 4.637 6.411 4.192 2.764-.493 6.371-2.4 6.666-6.776.1-1.479-1.354-2.735-2.316-3.747",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2889",
  d: "M76.818 106.745s.149 5.81 4.054 6.043c2.267.135 5.031.51 8.1-.917 2.088-.971 4.753-3.729 5.046-5.067.264-1.206-1.445-4.659-1.82-5.035",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2890",
  d: "M93.603 104.234c1.448.079 2.965.025 2.242 2.22-.5 1.516-1.926 7.415-4.533 8.573s-14.105-1.339-18.529 1.4-2.686 3.43-7.53 4.488-8.048 2.3-8.723.53 1.656-4.972 3.1-7.762 1.859-4.651 3.385-5.471 3.316-2.832 5.874-3.086 8.348-.768 8.348-.768",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2891",
  d: "M56.458 120.009c-1.273 2.013-1.36 5.446.1 6.166s8.2 1.279 10.75.455 4.528-2.56 6.65-3.636a15.9 15.9 0 017.482-1.627c3.1-.078 8.418.71 10.119-.186a3.1 3.1 0 011.411-3.112c1.941-1.079 3.742.876 3.772.862.985-.444 2.823-10.893 2.176-11.534a4.3 4.3 0 00-2.922-1.36",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2892",
  d: "M56.693 126.281c.679 1.4 2.793.83 3.455 1.807s-1.82 4.023 8.662 5.049",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2893",
  d: "M91.544 121.115c1.814 2.98 4.651 2.619 3.682 5.566s-4.726 6.645-3.289 11.14 7.125 11.042 9.725 15.974 4.133 8.885 5.946 10.65",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2894",
  d: "M96.786 118.87s1.93 3.663 2.065 5.714c.2 3-3.875 8.664-3.534 10.656s5.137 9.147 7.788 14.177c2.4 4.564 7.778 13.786 9.318 14.851",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2895",
  d: "M68.871 137.546c1.524 4.194 3.258 9.362 5.227 10.726a10.847 10.847 0 006.754 1.9c2.244-.173 7.021-2.4 8.068-3.966a8.779 8.779 0 001.582-5.285c-.1-1.848-4.309-11.139-4.309-11.139",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2896",
  d: "M137.751 121.882c2.543 4.431 5.849 9.748 6.111 14.309s-1.529 11.365-1.529 11.365",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2897",
  d: "M131.371 129.48c1.543 2.851 2.9 3.688 3.724 7.045s-.878 10.942-.878 10.942",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2898",
  d: "M135.174 140.195c-3.875-.641-12.458-2.02-17.736 1.609s-6.261 10.045-7.545 13.606a18.265 18.265 0 01-1.5 3.034",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2899",
  d: "M105.836 162.283a9.7 9.7 0 00-1.332 2.237",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2900",
  d: "M129.973 148.452c-3.414-1.019-6.21-1.836-8.486-.332a8.689 8.689 0 00-4.014 6.433c-.3 2.724.417 5.339-.469 6.7",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3244"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 17",
  cx: 5.595,
  cy: 7.573,
  rx: 5.595,
  ry: 7.573,
  transform: "rotate(-72.54 158.102 -64.724)",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3245"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 18",
  cx: 4.334,
  cy: 2.3,
  rx: 4.334,
  ry: 2.3,
  transform: "rotate(-11.141 478.592 -382.187)",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2901",
  d: "M98.95 107.4c-2.478-6.063-5.289-12.313-5.348-13.278s-.237-7.382-1.24-9.214c-.57-1.041-2.929-1.779-5.335-1.26-3.6.775-4.863 2.6-4.765 4.213s1.362 3.109 6.018 7.873c1 1.023 2.6 4.769 2.6 4.769",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2902",
  d: "M105.313 75.592c-13.2 5.007-58.048 20.377-58.048 20.377",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2903",
  d: "M48.421 92.56l44.778-15.125",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2904",
  d: "M219.579 73.881l59.145 18.79",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2905",
  d: "M231.657 74.737l45.656 14.151",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2906",
  d: "M186.558 93.823c2.249 1.313.577 4.886 4.476 9.086s6.711 3.111 6.748 7.46-.019 11.849-.019 11.849",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2907",
  d: "M164.712 114.339c-1.784 4.141-8.653 9.593-11.291 13.713s-2.919 10.477-5.22 14.646a47.376 47.376 0 01-3.344 4.934",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2908",
  d: "M184.236 134.549c-2.707.039-14.5-1.316-16.838-.063s-3.4 1.426-5.418 3.651-3.457 4.483-4.517 4.8-2.967 1.031-4.591 1.519-4.619 3.262-4.619 3.262",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3246"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2909",
  d: "M182.168 136.517c-2.708.039-11.649-.829-13.988.424s-3.4 1.426-5.417 3.651-3.458 4.483-4.517 4.8-4.131 1.1-5.724 2.462",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3247"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2910",
  d: "M190.632 92.774c2.855.783 15.273 3.251 26.094 1.754s15.164-1.982 18.126-.429 3.27 2.442 3.27 2.442",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3248"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2911",
  d: "M187.854 93.505c2.758.592 16.277 3.941 26.731 2.809s15.631-2.6 18.493-1.43 3.159 1.845 3.159 1.845",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2912",
  d: "M254.24 101.737l12.166-.312 1.118 1.17s13.347 1.177 15.244 1.886",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2913",
  d: "M228.945 76.955c-.761 1.964-2.4 10.612-2.74 16.33",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2914",
  d: "M226.186 94.884a7.994 7.994 0 00.341 3.2",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2915",
  d: "M54.83 93.505c-1.417 5.156-1.825 8.506.891 10.554s9.434 2.651 9.434 2.651",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2916",
  d: "M60.565 145.45s6.525-4.363 9.76-3.775",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2917",
  d: "M89.657 145.09c11.237.27 12.432 19.461 12.432 19.461",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3249"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2918",
  d: "M90.548 142.161a11.973 11.973 0 014.047.864",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3250"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2919",
  d: "M104.781 160.055a22.514 22.514 0 01.337 3.3",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2920",
  d: "M69.641 39.446c-6.152 10.073-16.86 33.673-11.132 31.873s37.477-6.817 37.477-6.817l6.858-23.836",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2921",
  d: "M224.05 39.453l5.074 23.512s40.563 8.109 40.167.969c-.229-4.122-11.369-27.972-11.369-27.972",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2922",
  d: "M109.713 40.828c5.622 6.077 5.606 19.556 22.487 19.061s65.035-1.623 71.419-1.8 8.125-16.977 14.489-18.291",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2923",
  d: "M55.622 37.994C43.05 55.852 1.501 112.194 1 153.703",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2924",
  d: "M270.504 31.706c8.3 12.017 64.384 83.9 61.379 143.413",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2925",
  d: "M1.239 193.535c10.042 14.184 32.623 30.2 63.827 40.267 27.562 8.89 61.2 9 94.4 9.489 46.481.686 76.926-1.711 99.934-7.072 21.733-5.067 40.377-17.18 56.225-30.969",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2926",
  d: "M324.81 130.017c-8.269 10.082-53.289 84.46-54.081 102.81",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2927",
  d: "M6.482 125.323c8.627 13.393 44.761 76.436 48.822 105.007",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2928",
  d: "M5.065 3.816c12.208 16.58 20.11 43.929 56.347 32.641s63.279-19.908 98.358-20.358 75.386 7.338 103.8 14.137 38.257-3.938 52.543-29.752",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2929",
  d: "M91.882 27.181c16.123 2.95 123.849 1.734 143.418-3.1",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

function SvgEngineCloseUpGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310.002,
    height: 244.393,
    viewBox: "0 0 333 244"
  }, props), _ref);
}

export default SvgEngineCloseUpGraphic;